// src/pages/openevents.js
import 'react-datepicker/dist/react-datepicker.css';
import DatePicker from 'react-datepicker';
import { addDays } from 'date-fns';
import React, { useEffect, useState } from 'react';
import { useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import supabase from '../config/supabaseClient';
import '../components/openevents.css';
import FilterIcon from '../icons/filtericon';
import RefreshIcon from '../icons/refreshicon';
import GeoapifyConfig from '../config/geoapifyConfig';
import SearchIcon from '../icons/searchicon';
import { useSession } from '@supabase/auth-helpers-react';
import { v4 as uuidv4 } from 'uuid';
import RequestInviteIcon from '../icons/requestinviteicon';
import CloseIcon from '../icons/closeicon';
import SendInviteIcon from '../icons/sendinviteicon';
import '../components/openevents.css';
import EventMap from './eventmap'; 
import MapIcon from '../icons/mapicon';




const GEOAPIFY_API_KEY = GeoapifyConfig.API_KEY;

/*
// Then use it:
const res = await fetch(`${GeoapifyConfig.BASE_URL}/geocode/search?text=...&apiKey=${GEOAPIFY_API_KEY}`);
*/

export default function OpenEvents() {
  const [contactInfo, setContactInfo] = useState('');
  const [showContactModal, setShowContactModal] = useState(false);
  const [contactEventId, setContactEventId] = useState(null);
  const [contactName, setContactName] = useState('');
  const [contactMessage, setContactMessage] = useState('');
  const [contactSocials, setContactSocials] = useState('');
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const [filteredEvents, setFilteredEvents] = useState([]);
  const session = useSession();
  const user = session?.user || null;
  const [locationInput, setLocationInput] = useState('');
  const [selectedLocation, setSelectedLocation] = useState('');
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [keywords, setKeywords] = useState('');
  const [radiusMiles, setRadiusMiles] = useState('');
  const [userCoords, setUserCoords] = useState(null);
  const [contactPhone, setContactPhone] = useState('');
  const [showMapModal, setShowMapModal] = useState(false);
  const [zipBounds, setZipBounds] = useState(null);
  const [errors, setErrors] = useState({name: false, email: false, message: false,});
  const flagToCountryCode = {
    '🇺🇸': 'us',
    '🇪🇸': 'es',
    '🇫🇷': 'fr',
    '🇩🇪': 'de',
    '🇯🇵': 'jp',
  };

  const [countryCode, setCountryCode] = useState('us'); // Default value

  const filterFromToday = (eventsList) => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return eventsList.filter((event) => {
    if (!event.event_date) return false;
    const eventDate = new Date(event.event_date);
    return !isNaN(eventDate) && eventDate >= today;
  });
};


  useEffect(() => {
    // 🔁 This will update countryCode based on selected flag
    const updateCountryCode = () => {
      const flag = localStorage.getItem('selectedLanguage') || '🇺🇸';
      const code = flagToCountryCode[flag] || 'us';
      setCountryCode(code);
    };

    // Run on first load
    updateCountryCode();

    // Listen for changes to selectedLanguage in localStorage
    const handleStorageChange = (e) => {
      if (e.key === 'selectedLanguage') {
        updateCountryCode();
      }
    };

    window.addEventListener('storage', handleStorageChange);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);


  const [locationSuggestions, setLocationSuggestions] = useState([]);
  const [sortOrder, setSortOrder] = useState('date'); // 'date', 'distanceAsc', 'distanceDesc'
  const [showSortMenu, setShowSortMenu] = useState(false);
  const [showFilters, setShowFilters] = useState(true); // purely visual
  const [radiusMilesRaw, setRadiusMilesRaw] = useState('');
  const searchRef = useRef();
  const haversineDistance = (coords1, coords2) => {
  const toRad = (x) => (x * Math.PI) / 180;
  const R = 6371; // Earth radius in kilometers
  
  const dLat = toRad(coords2.lat - coords1.lat);
  const dLon = toRad(coords2.lon - coords1.lon);
  const lat1 = toRad(coords1.lat);
  const lat2 = toRad(coords2.lat);

  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(lat1) * Math.cos(lat2) * Math.sin(dLon / 2) ** 2;

  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c;
};

  const geocodeLocation = async (placeName) => {
    const res = await fetch(
      `https://api.geoapify.com/v1/geocode/search?text=${encodeURIComponent(placeName)}&limit=1&apiKey=${GEOAPIFY_API_KEY}`
    );
    const data = await res.json();
    if (data.features && data.features.length > 0) {
      return {
        lat: data.features[0].geometry.coordinates[1],
        lon: data.features[0].geometry.coordinates[0],
      };
    }
    return null;
  };


const handleLocationChange = async (e) => {
  const query = e.target.value;
  setLocationInput(query);

  if (query.length < 3) {
    setLocationSuggestions([]);
    setUserCoords(null);  // Reset coords when query is too short
    return;
  }

  try {
        const res = await fetch(
          `https://api.geoapify.com/v1/geocode/autocomplete?text=${encodeURIComponent(query)}&limit=5&lang=en&filter=countrycode:${countryCode}&apiKey=${GEOAPIFY_API_KEY}`
        );
        const data = await res.json();
        setLocationSuggestions(data.features); // Geoapify returns "features" array

          } catch (err) {
            console.error('Autocomplete failed:', err);
          }
        };

  useEffect(() => {
    const handleStorageChange = () => {
    const flag = localStorage.getItem('selectedLanguage') || '🇺🇸';
    const updatedCode = flagToCountryCode[flag] || 'us';
    setCountryCode(updatedCode);
      };

      window.addEventListener('storage', handleStorageChange);

      return () => {
        window.removeEventListener('storage', handleStorageChange);
      };
    }, []);


  useEffect(() => {
    const handleClickOutside = (e) => {
      if (searchRef.current && !searchRef.current.contains(e.target)) {
        setLocationSuggestions([]); // ✅ close the dropdown
      }
    };

    document.addEventListener('click', handleClickOutside);

    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const fetchPublicEvents = async () => {
      const { data, error } = await supabase
        .from('hosting')
        .select('*')
        .eq('is_public', true)
        .order('event_date', { ascending: true });

      if (error) {
        console.error('Error fetching public events:', error);
      } else {
        setEvents(data);
        const futureOnly = filterFromToday(data);
        setFilteredEvents(futureOnly);


        if (userCoords) {
          const sortedByDistance = [...data].sort((a, b) => {
            const distA = haversineDistance(userCoords, {
              lat: a.event_lat,
              lon: a.event_lon,
            });
            const distB = haversineDistance(userCoords, {
              lat: b.event_lat,
              lon: b.event_lon,
            });
            return distA - distB;
          });
          setFilteredEvents(sortedByDistance);
        } else {
          setFilteredEvents(data);
        }

      }

      setLoading(false);
    };

    fetchPublicEvents();
  }, []);

  /*

// Removed auto-run geolocation to avoid prompting users for location on page load.
// This improves UX by preventing intrusive permission popups and supports users 
// who want to search events in other locations. Consider re-enabling only if 
// auto-detection of nearby events is essential to the app's core experience.

useEffect(() => {
  const getUserLocation = async () => {
    const cachedCity = sessionStorage.getItem('userCity');
    const cachedCoords = sessionStorage.getItem('userCoords');
      if (cachedCity && cachedCoords) {
        setSelectedLocation(cachedCity);
        setLocationInput(cachedCity);
        setUserCoords(JSON.parse(cachedCoords));
        return;
      }


    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        async (position) => {
          const lat = position.coords.latitude;
          const lon = position.coords.longitude;

          try {
            const res = await fetch(
              `https://api.geoapify.com/v1/geocode/reverse?lat=${lat}&lon=${lon}&apiKey=${GEOAPIFY_API_KEY}`
            );
            const data = await res.json();

          const city = data.features?.[0]?.properties?.city || data.features?.[0]?.properties?.county;
          const state = data.features?.[0]?.properties?.state_code;
          const cityName = [city, state].filter(Boolean).join(', ');

            if (cityName) {
              setSelectedLocation(cityName);
              setLocationInput(cityName);

              sessionStorage.setItem('userCity', cityName);
              sessionStorage.setItem('userCoords', JSON.stringify({ lat, lon }));
            }
          } catch (err) {
            console.error("Reverse geocoding failed:", err);
          }
        },
        (err) => {
          console.warn("User denied geolocation or error occurred:", err);
        }
      );
    }
  };

  getUserLocation();
}, []); 
*/ 


  if (loading) return <div style={{ padding: '2rem' }}>Loading open invites...</div>;

  if (events.length === 0) {
    return <div style={{ padding: '2rem' }}>No public events available yet.</div>;
  }

  /* Helper functions */

  const filterByLocation = (events, location) => {
    return events.filter(event =>
      (event.event_location || '').toLowerCase().includes(location.toLowerCase())
    );
  };

  const filterByDateRange = (events) => {
    if (!startDate || !endDate) return events;

    return events.filter((event) => {
      const eventDate = new Date(event.event_date);
      return eventDate >= startDate && eventDate <= endDate;
    });
  };


  const filterByKeywords = (events, keywords) => {
    const keywordList = keywords.toLowerCase().split(',').map(k => k.trim());
    return events.filter(event =>
      keywordList.some(k =>
        (event.event_name || '').toLowerCase().includes(k) ||
        (event.description || '').toLowerCase().includes(k)
      )
    );
  };

  const filterByRadius = (events, userCoords, radiusKm) => {
    return events
      .filter((event) => {
        if (event.event_lat == null || event.event_lon == null) return false;

        const distance = haversineDistance(userCoords, {
          lat: event.event_lat,
          lon: event.event_lon,
        });

        return distance <= parseFloat(radiusKm);
      })
      .sort((a, b) => {
        const distA = haversineDistance(userCoords, {
          lat: a.event_lat,
          lon: a.event_lon,
        });
        const distB = haversineDistance(userCoords, {
          lat: b.event_lat,
          lon: b.event_lon,
        });
        return distA - distB;
      });
  };

    const handleSearch = () => {
      setRadiusMiles(radiusMilesRaw);
      let filtered = [...events];

    if (radiusMilesRaw && userCoords) {
      const radiusKm = parseFloat(radiusMilesRaw) * 1.60934;
      filtered = filterByRadius(filtered, userCoords, radiusKm);
    }


    if (startDate && endDate) {
      filtered = filterByDateRange(filtered);
    }

    if (keywords) {
      filtered = filterByKeywords(filtered, keywords);
    }

    if (radiusMiles && userCoords) {
      const radiusKm = parseFloat(radiusMiles) * 1.60934; // Convert miles to km
      filtered = filterByRadius(filtered, userCoords, radiusKm);
    } else if (selectedLocation) {
      filtered = filterByLocation(filtered, selectedLocation);
    }

    // 🔽 Apply sorting based on user selection
    if (sortOrder === 'distanceAsc' && userCoords) {
      filtered.sort((a, b) =>
        haversineDistance(userCoords, { lat: a.event_lat, lon: a.event_lon }) -
        haversineDistance(userCoords, { lat: b.event_lat, lon: b.event_lon })
      );
    } else if (sortOrder === 'distanceDesc' && userCoords) {
      filtered.sort((a, b) =>
        haversineDistance(userCoords, { lat: b.event_lat, lon: b.event_lon }) -
        haversineDistance(userCoords, { lat: a.event_lat, lon: a.event_lon })
      );
    } else {
      filtered.sort((a, b) => new Date(a.event_date) - new Date(b.event_date)); // default: by date
    }

    setFilteredEvents(filtered);
  };


  const handleClearFilters = () => {
    setLocationInput('');
    setSelectedLocation('');
    setStartDate(null);
    setEndDate(null);
    setKeywords('');
    setRadiusMiles('');
    setUserCoords(null);
    sessionStorage.removeItem('userCoords');

    const futureEvents = filterFromToday(events);
    setFilteredEvents(futureEvents);
  };

  const handleContactSubmit = async () => {
    const newErrors = {
      name: !contactName.trim(),
      email: !contactInfo.trim(),
      message: !contactMessage.trim(),
    };

    setErrors(newErrors);

    const hasErrors = Object.values(newErrors).some(Boolean);
    if (hasErrors) {
      return; // prevent submission
    }

    const { error } = await supabase.from('event_requests').insert([
      {
        event_id: contactEventId,
        user_id: null,
        name: contactName,
        message: contactMessage,
        social_contact: contactSocials,
        email: contactInfo,
        phone: contactPhone,
        status: 'pending',
        seen_by_host: false,
      },
    ]);

    if (error) {
      console.error('Error submitting contact request:', error);
      alert('❌ Something went wrong.');
    } else {
      alert('✅ Your message was sent to the host!');
      setShowContactModal(false);
    }
  };

        
  const handleKeyDown = async (e) => {
    if (e.key === 'Enter') {
      if (/^\d{5}$/.test(locationInput.trim())) {
        // ZIP logic...
        const zip = locationInput.trim();
        try {
          const res = await fetch(
            `https://api.geoapify.com/v1/geocode/search?text=${zip}&filter=countrycode:us&format=json&apiKey=${GEOAPIFY_API_KEY}`
          );
          const data = await res.json();

          if (data.results?.length > 0 && data.results[0].bbox) {
            const bbox = data.results[0].bbox;
            const bounds = [
              [bbox.lat1, bbox.lon1],
              [bbox.lat2, bbox.lon2]
            ];
            setZipBounds(bounds);
            console.log('📍 ZIP bounds set:', bounds);
          } else {
            console.warn('No bounding box returned for ZIP');
          }
        } catch (error) {
          console.error('Error geocoding ZIP:', error);
        }
      } else {
        // Just refresh map with current keyword + bounds
        setZipBounds(null); // Optionally clear bounds if not a ZIP
      }
    }
  };




  const formatDate = (date) => {
    if (!date) return '';
    return date.toLocaleDateString(undefined, {
      month: 'short',
      day: 'numeric',
    });
  };


 return (
  <div style={{ paddingTop: '4rem' }}>
    <div style={{ position: 'relative', maxWidth: '900px', margin: '0 auto' }}>
      {/* Floating Filter + Reset Icons */}
      <div
        style={{
          position: 'absolute',
          top: '-2.5rem',
          left: '50%',
          transform: 'translateX(-50%)',
          display: 'flex',
          gap: '0.75rem',
          zIndex: 10,
        }}
      >

        <button
          onClick={() => setShowSortMenu(prev => !prev)}
          style={{
            background: 'none',
            border: 'none',
            color: '#333',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            gap: '0.3rem',
            fontWeight: 'bold',
          }}
        >
          <FilterIcon size={20} />
          Filter
        </button>

        <button
          onClick={handleClearFilters}
          style={{
            background: 'none',
            border: 'none',
            color: '#333',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            gap: '0.3rem',
            fontWeight: 'bold',
          }}
        >
          <RefreshIcon size={20} />
          Reset
        </button>

        <button
          onClick={() => setShowMapModal(true)}
          style={{
            background: 'none',
            border: 'none',
            color: '#333',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            gap: '0.3rem',
            fontWeight: 'bold',
          }}
        >
          <MapIcon size={20} />
          Map
        </button>
      </div>

      <div className="event-search-bar">
        <div ref={searchRef} style={{ position: 'relative', flex: 1 }}>
          <input
            type="text"
            placeholder="Where"
            value={locationInput}
            onChange={handleLocationChange}
            onKeyDown={handleKeyDown}
            className="where-input"
          />

          {Array.isArray(locationSuggestions) &&
            locationSuggestions.length > 0 && (
              <ul
                style={{
                  position: 'absolute',
                  top: '100%',
                  left: 0,
                  right: 0,
                  background: 'white',
                  border: '1px solid #ddd',
                  zIndex: 1000,
                  listStyle: 'none',
                  margin: 0,
                  padding: '0.5rem 0',
                  maxHeight: '150px',
                  overflowY: 'auto',
                }}
              >
                {locationSuggestions.map((sugg, idx) => {
                  const city = sugg.properties.city || sugg.properties.county;
                  const state = sugg.properties.state_code;
                  const label = [city, state].filter(Boolean).join(', ');

                  return (
                    <li
                      key={idx}
                      onClick={async () => {
                        setSelectedLocation(label);
                        setLocationInput(label);
                        setLocationSuggestions([]);

                        const coords = {
                          lat: sugg.geometry.coordinates[1],
                          lon: sugg.geometry.coordinates[0],
                        };

                        setUserCoords(coords);
                        sessionStorage.setItem(
                          'userCoords',
                          JSON.stringify(coords)
                        );
                      }}
                    >
                      {label}
                    </li>
                  );
                })}
              </ul>
            )}
        </div>

        <DatePicker
          selectsRange
          startDate={startDate}
          endDate={endDate}
          onChange={([start, end]) => {
            setStartDate(start);
            setEndDate(end);
          }}
          isClearable={false}
          placeholderText="Date(s)"
          dateFormat="MMM d" // ✅ This removes the year
          className="custom-datepicker"
          wrapperClassName="datepicker-wrapper"
        />

        <input
          type="text"
          placeholder="Keywords (e.g., tennis, golf...)"
          value={keywords}
          onChange={(e) => setKeywords(e.target.value)}
          onKeyDown={handleKeyDown}
          className="keyword-input"
        />

      <div className="suffix-input">
        <input
          type="text"
          className="radius-input"
          value={radiusMilesRaw}
          placeholder="Miles"
          inputMode="numeric"
          pattern="\d*"
          min="0"
          step="1"
          onChange={(e) => {
            // Keep it digits-only, allow empty while editing
            const v = e.target.value.replace(/\D/g, '');
            setRadiusMilesRaw(v);
          }}
          onKeyDown={handleKeyDown}          // keep Enter-to-search behavior
          onWheel={(e) => e.currentTarget.blur()} // prevent scroll changing value
        />
      </div>



      <button type="button" className="search-button" onClick={handleSearch}>
        <SearchIcon size={22} color="white" />
      </button>


      </div>
    </div>

    {filteredEvents.length === 0 ? (
      <div style={{ padding: '2rem', textAlign: 'center', color: '#666' }}>
        No events match your search.
      </div>
    ) : (
      <div className="event-grid">
        {filteredEvents.map((event, index) => (
          <div
            className="event-tile"
            key={event.id || index}
            onClick={() => navigate(`/event/${event.id}`)}
            title="Click to view event"
          >
            <img
              src={event.image || event.event_image}
              alt={event.name || event.event_name}
              className="event-image"
            />
            <div className="event-info">
              <p className="event-name">{event.name || event.event_name}</p>
              <p className="event-meta">
                {event.event_date
                  ? `Date: ${new Date(event.event_date).toLocaleDateString(undefined, {
                      weekday: 'short',
                      month: 'short',
                      day: 'numeric',
                    })}`
                  : 'Date TBA'}
              </p>
              <p className="event-meta">
                Location: {event.event_location || 'TBD'}
              </p>
              {userCoords && event.event_lat && event.event_lon && (
                <p className="event-meta">
                  ~
                  {Math.round(
                    haversineDistance(userCoords, {
                      lat: event.event_lat,
                      lon: event.event_lon,
                    })
                  )}{' '}
                  km away
                </p>
              )}
              <button
                className="icon-only-button"
                onClick={(e) => {
                  e.stopPropagation();
                  setContactEventId(event.id);
                  setShowContactModal(true);
                }}
                title="Contact Host"
              >
                <RequestInviteIcon size={20} />
              </button>
            </div>
          </div>
        ))}
      </div>
    )}
      {showContactModal && (
        <div className="modal-overlay" onClick={() => setShowContactModal(false)}>
          <div
            className="modal-content"
            onClick={(e) => e.stopPropagation()}
            style={{ maxWidth: '500px', width: '90%' }}
          >
            <h3 style={{ marginBottom: '1rem' }}>Send a Message to the Moderator</h3>

            <input
              type="text"
              placeholder="Name *"
              value={contactName}
              onChange={(e) => {
                setContactName(e.target.value);
                setErrors((prev) => ({ ...prev, name: false }));
              }}
              style={{
                width: '100%',
                marginBottom: '10px',
                borderColor: errors.name ? 'red' : '#ccc',
              }}
            />

            <input
              type="email"
              placeholder="Email *"
              value={contactInfo}
              onChange={(e) => {
                setContactInfo(e.target.value);
                setErrors((prev) => ({ ...prev, email: false }));
              }}
              style={{
                width: '100%',
                marginBottom: '10px',
                borderColor: errors.email ? 'red' : '#ccc',
              }}
            />

            <input
              type="text"
              placeholder="Phone Number (optional)"
              value={contactPhone}
              onChange={(e) => setContactPhone(e.target.value)}
              style={{ width: '100%', marginBottom: '10px' }}
            />

            <input
              type="text"
              placeholder="Optional social links (Instagram, etc.)"
              value={contactSocials}
              onChange={(e) => setContactSocials(e.target.value)}
              style={{ width: '100%', marginBottom: '10px' }}
            />

            <textarea
              placeholder="Your message *"
              value={contactMessage}
              onChange={(e) => {
                setContactMessage(e.target.value);
                setErrors((prev) => ({ ...prev, message: false }));
              }}
              rows={4}
              style={{
                width: '100%',
                marginBottom: '10px',
                borderColor: errors.message ? 'red' : '#ccc',
              }}
            />

            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <span
                className="modal-icon-button"
                onClick={() => setShowContactModal(false)}
                title="Cancel"
                role="button"
                tabIndex={0}
              >
                <CloseIcon size={22} color="#333" />
              </span>

              <span
                className="modal-icon-button"
                onClick={handleContactSubmit}
                title="Send"
                role="button"
                tabIndex={0}
              >
                <SendInviteIcon size={22} color="#333" />
              </span>

            </div>
          </div>
        </div>
      )}

        {showMapModal && (
          <div className="modal-overlay" onClick={() => setShowMapModal(false)}>
            <div
              className="modal-content"
              onClick={(e) => e.stopPropagation()}
              style={{ maxWidth: '700px', width: '95%', height: '80vh', padding: '1rem', position: 'relative' }}
            >
              {/* Close Button */}
              <span
                className="modal-icon-button"
                onClick={() => setShowMapModal(false)}
                title="Close Map"
                role="button"
                tabIndex={0}
                style={{ position: 'absolute', top: '0.75rem', right: '0.75rem', zIndex: 1000 }}
              >
                <CloseIcon size={22} />
              </span>

              <h3 style={{ marginBottom: '0.75rem' }}>Search Events by Map</h3>

              <div style={{ display: 'flex', gap: '0.5rem', marginBottom: '0.75rem' }}>
                  <input
                    type="text"
                    placeholder="Enter ZIP code"
                    value={locationInput}
                    onChange={handleLocationChange}
                    onKeyDown={handleKeyDown} // ✅ ADD THIS LINE
                    className="where-input"
                    style={{ flex: 1 }}
                  />

                <input
                  type="text"
                  placeholder="Search keyword (e.g. tennis)"
                  value={keywords}
                  onChange={(e) => setKeywords(e.target.value)}
                  className="keyword-input"
                  style={{ flex: 1 }}
                />
              </div>

              {/* Map Component */}
              <div style={{ flex: 1, height: '100%' }}>
                <EventMap events={filterByKeywords(filteredEvents, keywords)} bounds={zipBounds} />
              </div>
            </div>
          </div>
        )}

  </div>
);
}